





























































































































































import Vue from 'vue';

export default Vue.extend({
  props: {
    recibosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    conceptosDialog: false,
    loading: false,
    conceptos: [],
    conceptosTemp: [],
    nuevoItem: {},
    conceptosFiltro: [],
    filtro: {},
    headers: [
      { text: 'Propietario', value: 'propietario.nombre' },
      // { text: 'Recibo ID', value: 'id' },
      // { text: 'Administración', value: 'administracion.shortName' },
      { text: 'Concepto', value: 'item.concepto.nombre' },
      { text: 'Descripción', value: 'item.descripcion' },
      { text: 'Unidad', value: 'unidad.name' },
      { text: 'Cantidad', value: 'item.cantidad' },
      { text: 'Precio Unitario', value: 'item.unitario' },
      { text: 'Importe', value: 'item.importe' },
    ],
    recibosTabla: [],
    selectedItems: [],
    recibos: [],
    precision: 2,
    selectedConcepto: '',
    nuevaDescripcion: '',
  }),
  methods: {
    restrictChars($event , e) {
      if (/[0-9]/.test(String.fromCharCode($event.charCode)) ||
          ($event.charCode === 46) && (e.indexOf('.') === -1) ) {
        return true;
      } else {
          $event.preventDefault();
      }
    },
    closeConceptosDialog() {
      this.conceptosDialog = false;
      this.selectedConcepto = '';
      this.selectedItems = [];
    },
    async guardarBorradores() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        this.modifyRecibosFromTabla(this.recibos, this.recibosTabla);
        const borradores = this.recibos;
        const datos = {admin, condo, borradores};
        console.log('addRecurrentes datos: %o', datos);
        const response = await this.$store.dispatch('addRecurrentes', {datos});
        console.log('addRecurrentes response: %o', response);
        this.$toast.success('Recibos Persistentes modificados exitosamente');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.closeConceptosDialog();
    },
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        console.log('getConceptoList1 datos: %o', datos);
        const response = await this.$store.dispatch('getConceptoList1', {datos});
        console.log('getConceptoList1 response: %o', response);
        this.conceptosTemp = response.content;
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      for (const conp of this.conceptosTemp) {
        try {
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const concepto = conp;
          const datos = {admin, condo, concepto};
          const response = await this.$store.dispatch('getConceptoById', datos);
          this.conceptos.push(response);
        } catch (e) {
          console.error(e);
          this.$toast.error(e);
        }
      }
      this.loading = false;
    },
    isItemValid(item) {
      if (Object.keys(item.concepto).length === 0 || item.cantidad === '' || item.unitario === '') {
        return false;
      }
      return true;
    },
    fillNumericDataOfItem(item) {
        item.cantidad = Number(item.cantidad);
        item.unitario = Number(item.unitario);
        item.importe = (item.cantidad * item.unitario).toFixed(this.precision);
        item.impuestos.baseImp = item.importe;
        item.impuestos.importeImp = (item.impuestos.baseImp
        * item.impuestos.imp.tasa).toFixed(this.precision);
    },
    agregarConceptoATodos() {
      // console.log('agregarConcepto ', this.nuevoItem);
      if (this.isItemValid(this.nuevoItem)) {
        this.fillNumericDataOfItem(this.nuevoItem);
        this.modifyRecibosFromTabla(this.recibos, this.recibosTabla);
        for (const recibo of this.recibos) {
          const item = JSON.parse(JSON.stringify(this.nuevoItem));
          recibo.items.push(item);
        }
        this.recibosTabla = this.generateRecibosTabla(this.recibos);
      } else {
        this.$toast.error('Es necesario escoger un concepto, la cantidad y el precio unitario');
        return;
      }
      this.nuevoItem = this.modeloNuevoItem();
      this.selectedConcepto = {};
    },
    agregarConceptoASeleccionados() {
      // console.log('agregarConcepto ', this.nuevoItem);
      if (this.isItemValid(this.nuevoItem)) {
        this.fillNumericDataOfItem(this.nuevoItem);
        this.modifyRecibosFromTabla(this.recibos, this.recibosTabla);
        for (const recibo of this.recibos) {
          if (this.isReciboInSelected(recibo)) {
            const item = JSON.parse(JSON.stringify(this.nuevoItem));
            recibo.items.push(item);
          }
        }
        this.recibosTabla = this.generateRecibosTabla(this.recibos);
      } else {
        this.$toast.error('Es necesario escoger un concepto, la cantidad y el precio unitario');
        return;
      }
      this.nuevoItem = this.modeloNuevoItem();
      this.selectedConcepto = {};
    },
    isReciboInSelected(recibo) {
      for (const item of this.selectedItems) {
        if (recibo.condominio.id === item.condominio.id && recibo.unidad.id === item.unidad.id) {
          return true;
        }
      }
      return false;
    },
    isReciboTablaInFilter(reciboTabla) {
      if (this.filtro.valor.length === 0 || this.filtro.valor === reciboTabla.item.concepto.nombre) {
        return true;
      }
      return false;
    },
    isReciboTablaInSelected(reciboTabla) {
      for (const sel of this.selectedItems) {
        if (reciboTabla.key === sel.key) {
          return true;
        }
      }
      return false;
    },
    isSelectedEmpty() {
      if (this.selectedItems.length === 0) {
        return true;
      }
      return false;
    },
    generateRecibosTabla(recibosArray) {
      const recibosTablaArray: any[] = [];
      for (const recibo of recibosArray) {
        let index = 0;
        for (const item of recibo.items) {
          const newRecibo = this.modeloReciboTabla();
          newRecibo.key = 'recibo' + recibo.id + 'index' + index;
          newRecibo.id = recibo.id;
          newRecibo.administracion = Object.assign({}, recibo.administracion);
          newRecibo.condominio = Object.assign({}, recibo.condominio);
          newRecibo.propietario = Object.assign({}, recibo.propietario);
          newRecibo.unidad = Object.assign({}, recibo.unidad);
          newRecibo.item = Object.assign({}, item);
          recibosTablaArray.push(newRecibo);
          index++;
        }
      }
      return recibosTablaArray;
    },
    modifyRecibosFromTabla(recibosArray, tablaArray) {
      for (const recibo of recibosArray) {
        recibo.items = [];
        for (const reciboTabla of tablaArray) {
          if (recibo.id === reciboTabla.id) {
            reciboTabla.item.impuestos.baseImp = reciboTabla.item.importe;
            reciboTabla.item.impuestos.importeImp = (reciboTabla.item.importe
              * reciboTabla.item.impuestos.imp.tasa).toFixed(this.precision);
            const newItem = Object.assign({}, reciboTabla.item);
            recibo.items.push(newItem);
          }
        }
        const totales = this.getTotales(recibo);
        recibo.subtotal = totales.subtotal.toFixed(this.precision);
        recibo.totalImpuestos = totales.totalImpuestos.toFixed(this.precision);
        recibo.total = totales.total.toFixed(this.precision);
      }
    },
    getTotales(recibo) {
      const returnObject = {
        subtotal: 0,
        totalImpuestos: 0,
        total: 0,
      };
      for (const item of recibo.items) {
        if (!item.concepto.adeudo) {
          returnObject.subtotal += Number(item.impuestos.baseImp);
          returnObject.totalImpuestos += Number(item.impuestos.importeImp);
        }
      }
      returnObject.total = returnObject.subtotal + returnObject.totalImpuestos;
      return returnObject;
    },
    modeloReciboTabla() {
      return {
        key: '',
        id: 0,
        administracion: {},
        condominio: {},
        propietario: {},
        unidad: {},
        item: {},
      };
    },
    modeloNuevoItem() {
      return {
        concepto: {},
        descripcion: '',
        unidadDeMedida: '',
        cantidad: '',
        unitario: '',
        importe: 0,
        impuesto: '',
        impuestos: {
          baseImp: 0,
          importeImp: 0,
          imp: {},
        },
      };
    },
    eliminarItems() {
      const indexArray: any[] = [];
      for (let i = 0; i < this.recibosTabla.length; i++) {
        if (this.isReciboTablaInSelected(this.recibosTabla[i])) {
          indexArray.push(i);
        }
      }
      for (let i = indexArray.length - 1; i >= 0 ; i--) {
        this.recibosTabla.splice(indexArray[i], 1);
      }
      this.selectedItems = [];
      this.modifyRecibosFromTabla(this.recibos, this.recibosTabla);
    },
    cambiarDescripcionesVisibles() {
      for (const recibo of this.recibosTabla) {
        if (this.isReciboTablaInFilter(recibo)) {
          recibo.item.descripcion = this.nuevaDescripcion;
        }
      }
    },
    cambiarDescripcionesSeleccionados() {
      for (const recibo of this.recibosTabla) {
        if (this.isReciboTablaInFilter(recibo) && this.isReciboTablaInSelected(recibo)) {
          recibo.item.descripcion = this.nuevaDescripcion;
        }
      }
    },
  },
  watch: {
    async conceptosDialog() {
      if (this.conceptosDialog) {
        await this.loadData();
        this.conceptosFiltro = Array.from([]);
        this.filtro = {nombre: 'Todos los conceptos', valor: '', descripcion: ''};
        this.conceptosFiltro.push(JSON.parse(JSON.stringify(this.filtro)));
        for (const concepto of this.conceptos) {
          concepto.valor = concepto.nombre;
          this.conceptosFiltro.push(concepto);
        }
        this.nuevoItem = this.modeloNuevoItem();
        this.recibos = JSON.parse(JSON.stringify(this.recibosInit));
        this.recibosTabla = this.generateRecibosTabla(this.recibos);
      } else {
        this.$emit('reload', {});
        this.recibosTabla = [];
        this.recibos = [];
        this.conceptos = [];
        this.nuevoItem = this.modeloNuevoItem();
        this.filtro = {};
      }
    },
    selectedConcepto(event) {
      if (Object.keys(event).length > 0) {
        this.nuevoItem.concepto = event;
        this.nuevoItem.impuestos.imp = event.impuesto;
        this.nuevoItem.descripcion = event.descripcion;
        this.nuevoItem.impuesto = event.impuesto.descripcion;
        this.nuevoItem.unidadDeMedida = event.unidadMedida;
      }
    },
    filtro() {
      this.nuevaDescripcion = this.filtro.descripcion;
    },
  },
});
